import * as api from '../stores/api';

const apiResetStore = () =>
  Object.values(api)
    .filter(q => q.fetched)
    .forEach(q => q.reset());

export default apiResetStore;
